import styled from 'styled-components';
import { Button, mq, backgroundGradient } from '@phishtool/ui';
import { Heading } from '~components/heading';
export const StyledHeroWrapper = styled.div.withConfig({ displayName: "StyledHeroWrapper", componentId: "sc-cp3prg" }) `
  ${backgroundGradient}
`;
export const StyledHeading = styled(Heading).withConfig({ displayName: "StyledHeading", componentId: "sc-hkv9wt" }) `
  margin-bottom: ${(props) => props.theme.spacers.x3};

  ${(props) => mq({
    marginTop: [props.theme.spacers.x4, null, props.theme.spacers.x8],
})}
`;
export const StyledCTA = styled(Button).withConfig({ displayName: "StyledCTA", componentId: "sc-1smp7vo" }) `
  ${(props) => props.theme.responsiveFontsize.body.medium}
  flex: 1;
  min-width: 0;

  ${(props) => mq({
    flex: [1, 'none'],
    width: ['auto', props.large ? '255px' : '160px', props.large ? '468px' : '255px'],
    height: [props.theme.spacers.x6, null, props.theme.spacers.x9],
})}
`;
export const StyledHeroImageWrapper = styled.div.withConfig({ displayName: "StyledHeroImageWrapper", componentId: "sc-1onq3kf" }) `
  position: relative;
`;
export const StyledHeroImageBackground = styled.div.withConfig({ displayName: "StyledHeroImageBackground", componentId: "sc-1ryt68o" }) `
  position: absolute;
  top: 0;
  left: 0;
  height: 50%;
  width: 100%;
  ${backgroundGradient}
`;
export const StyledHeroImage = styled.img.withConfig({ displayName: "StyledHeroImage", componentId: "sc-16ek8kk" }) `
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  aspect-ratio: 1.756;

  ${(props) => mq({
    boxShadow: props.theme.shadows.tertiary,
    borderRadius: ['5px', '10px', '15px'],
})}
`;
